import appConfig from '@/constants/appConfig'
import { useAppStore } from '@/stores/app'

export function getAuthHeaders(isContentTypeNotRequired?: boolean): Record<string, string> {
  const accessToken = localStorage.getItem('accessToken')
  const appStore = useAppStore()

  if (!accessToken) {
    throw new Error('No access token found in local storage')
  }

  if (isContentTypeNotRequired) {
    return {
      Authorization: `Bearer ${accessToken}`,
      'portal-id': appStore.getPortalId?.toString() || '',
      'trace-session-id': appStore.getTraceSessionId || '',
      'x-client-app': appConfig.CLIENT_APP,
      'langfuse-project-id': import.meta.env.VITE_APP_TRACKING_PROJECT_ID || '',
      Portal: import.meta.env.DEV ? 'be.stunnr.co' : window.location.hostname,
      'Client-Id': appConfig.STUNNR_BE_CLIENT_ID
    }
  }

  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
    'portal-id': appStore.getPortalId?.toString() || '',
    'trace-session-id': appStore.getTraceSessionId || '',
    'x-client-app': appConfig.CLIENT_APP,
    'langfuse-project-id': import.meta.env.VITE_APP_TRACKING_PROJECT_ID || '',
    Portal: import.meta.env.DEV ? 'be.stunnr.co' : window.location.hostname,
    'Client-Id': appConfig.STUNNR_BE_CLIENT_ID
  }
}

export function getAuthHeadersForEnhancements(isContentTypeNotRequired?: boolean): Record<string, string> {
  if (isContentTypeNotRequired) {
    return {
      Authorization: 'Bearer rpa_ZHWUGPOYRPW7USVI23IET0F82ED0THN1VS8E07M51un8uo'
    }
  }

  return {
    'Content-Type': 'application/json',
    Authorization: 'Bearer rpa_ZNA5MXSUXNOEM1RZ2YIMD0RUSN5CHWE7STQ7QGFD03l3eg',
  }
}

export function getAuthBodyForEnhancements(): Record<string,string>{
  const accessToken = localStorage.getItem('accessToken')
  return {
    "dx-user-auth": `Bearer ${accessToken}`
  }
}
